module.exports = __webpack_public_path__ + "img/ARCH_09_prew.d5460dd1.jpg";